import { createAsyncThunk } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'

export interface PurchaseWithExistingCardParams {
  order_number: string
  existing_card: number
  installments: number
}

export const purchaseWithExistingCard = createAsyncThunk(
  'purchase-with-existing-card',
  async ({ order_number, existing_card, installments }: PurchaseWithExistingCardParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.put(`/api/v1/checkouts/${order_number}`, {
        order: {
          existing_card,
          payments_attributes: [{ installments }]
        }
      })

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
